import { render, staticRenderFns } from "./WidgetBestCampaigns.vue?vue&type=template&id=434f7294"
import script from "./WidgetBestCampaigns.vue?vue&type=script&lang=js"
export * from "./WidgetBestCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports